import { CONNECTION_APP_SECTIONS } from '@/data/connectionAppsCatalog/connectionAppsCatalogSections.js'
import { INTEGRATION_FILTER_CATEGORIES } from './integrationsCategories.js'

/** @typedef {{ slug: string, title: string, description: string, icon?: string, sectionId: string, sectionTitle: string }} MarketplaceApp */

export const POPULAR_INTEGRATION_SLUGS = [
  'gmail',
  'outlook',
  'google-calendar',
  'google-drive',
  'twitter',
  'google-sheets',
  'supabase',
  'notion',
  'slack',
  'airtable',
]

/** @returns {MarketplaceApp[]} */
export function getAllMarketplaceApps() {
  return CONNECTION_APP_SECTIONS.flatMap((section) =>
    section.apps.map((app) => ({
      slug: app.slug,
      title: app.title,
      description: app.description,
      icon: app.icon,
      sectionId: section.id,
      sectionTitle: section.title,
    })),
  )
}

/**
 * @param {MarketplaceApp[]} apps
 * @param {{ categoryId: string, query: string }} filters
 */
export function filterMarketplaceApps(apps, { categoryId, query }) {
  let list = apps

  const category = INTEGRATION_FILTER_CATEGORIES.find((c) => c.id === categoryId)
  if (category?.sectionId) {
    list = list.filter((a) => a.sectionId === category.sectionId)
  }

  const q = query.trim().toLowerCase()
  if (q) {
    list = list.filter(
      (a) =>
        a.title.toLowerCase().includes(q) ||
        a.description.toLowerCase().includes(q) ||
        a.sectionTitle.toLowerCase().includes(q),
    )
  }

  return list
}

/** @param {MarketplaceApp[]} apps */
export function getPopularMarketplaceApps(apps) {
  const bySlug = new Map(apps.map((a) => [a.slug, a]))
  return POPULAR_INTEGRATION_SLUGS.map((slug) => bySlug.get(slug)).filter(Boolean)
}

export { INTEGRATION_FILTER_CATEGORIES }
